import React from 'react';
import {riskTypeIdentifiers} from "../../../routes";
import {RiskRowBox} from "./RiskRowBox";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getPanelLink} from "../DashboardPanels/panelCommon";
import {TotalPanel} from "../TotalPanel";
import {getNewAppsInOrgCount} from "../../../services/Discovery/Discovery";

interface NewAppsIsOrgCountProps {
  numberInCircle: number;
}
export const NewAppsInOrgCount = (props: NewAppsIsOrgCountProps) => {

  const {isLoading, data, isError} = useQueryWithAccessToken({
      queryKey: [cacheKeys.newAppsInOrgCount],
      queryFunction: getNewAppsInOrgCount,
      queryFunctionVariables:{}
    }
  );


  return (<RiskRowBox>
    <TotalPanel
      totalCount={data}
      title="New apps in Org"
      description={<span><em>Apps that have been added to your org in the last 28 days</em></span>}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.newAppsInOrg, data)}
      numberInCircle={props.numberInCircle}
      isLoading={isLoading}
      isError={isError}
    />
  </RiskRowBox>)
};
